"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CheckboxIcon = (props) => {
    const { icon, iconSize, iconLabelPosition, text } = props;
    const iconStyles = {
        width: `${iconSize}px`,
        height: `${iconSize}px`,
        fontSize: `${iconSize}px`,
        lineHeight: `${iconSize}px`,
    };
    return ((0, jsx_runtime_1.jsxs)("span", Object.assign({ className: `checkbox-icon label-${iconLabelPosition}` }, { children: [(0, jsx_runtime_1.jsx)("span", { className: `rioglyph ${icon}`, style: iconStyles }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'checkbox-label' }, { children: text }))] })));
};
exports.CheckboxIcon = CheckboxIcon;
